import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowCollapseLeftIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 25.6 25.6",
	style: { enableBackground: "new 0 0 25.6 25.6" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n	.arrow_collapse_left-icon-st0{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n	.arrow_collapse_left-icon-st1{fill:currentColor;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}\n"
		}),
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			className: "arrow_collapse_left-icon-st0",
			d: "M12.9,17.5l-4.7-4.7l4.7-4.7"
		}), /* @__PURE__ */ _jsx("path", {
			className: "arrow_collapse_left-icon-st0",
			d: "M20.7,12.8H8.2"
		})] }),
		/* @__PURE__ */ _jsx("path", {
			className: "arrow_collapse_left-icon-st1",
			d: "M21.6,0.5H4C2.1,0.5,0.5,2.1,0.5,4v17.6c0,1.9,1.6,3.5,3.5,3.5h17.6c1.9,0,3.5-1.6,3.5-3.5V4 C25.1,2.1,23.5,0.5,21.6,0.5z M24.1,21.8c0,1.3-1.1,2.4-2.4,2.4H7.2c-1.3,0-2.4-1.1-2.4-2.4V4c0-1.3,1.1-2.4,2.4-2.4h14.6 c1.3,0,2.4,1.1,2.4,2.4V21.8z"
		})
	]
});
export default SvgArrowCollapseLeftIcon;
